import { createMuiTheme } from "@material-ui/core"

export const defaultThemeValues = {
    fontSizes: {
        small: "0.75rem",
        default: "1rem",
        medium: "1.25rem",
        large: "1.5rem",
        xLarge: "2rem",
        xxLarge: "2.5rem",
        title: {
            default: "2rem",
            h4: "1.5rem",
        },
    },
    spaces: {
        smallScale: {
            xxs: "0.25rem",
            xs: "0.5rem",
            s: "0.75rem",
            m: "1rem",
            l: "1.5rem",
            xl: "2rem",
            xxl: "3rem",
            xxxl: "4rem",
        },
        largeScale: {
            xxs: "6rem",
            xs: "8rem",
            s: "12rem",
            m: "16rem",
            l: "24rem",
            xl: "32rem",
            xxl: "40rem",
            xxxl: "48rem",
        },
    },
    colors: {
        primary: {
            1000: "#0D0F87",
            900: "#171CBA",
            800: "#3134DD",
            700: "#434BEA",
            600: "#5B5DEC",
            500: "#6D6DF3",
            400: "#878CF8",
            300: "#A2A7FB",
            200: "#C4C7FD",
            100: "#E7E8FE",
        },
        secondary: {
            1000: "#014B3F",
            900: "#0C6A57",
            800: "#147B63",
            700: "#199473",
            600: "#27AA83",
            500: "#3DBD92",
            400: "#66D6AD",
            300: "#8CEDC6",
            200: "#C5F7E1",
            100: "#EEFCF5",
        },
        grey: {
            1000: "#102A42",
            900: "#243A52",
            800: "#324D67",
            700: "#48647F",
            600: "#617D98",
            500: "#829AB0",
            400: "#9EB2C7",
            300: "#BCCCDC",
            200: "#DAE2EC",
            100: "#F1F5F8",
        },
        yellow: {
            1000: "#8D2B0B",
            900: "#B44B12",
            800: "#CB6E17",
            700: "#DE911D",
            600: "#F0B429",
            500: "#F7C948",
            400: "#FADB5F",
            300: "#FCE588",
            200: "#FFF3C4",
            100: "#FFFBEA",
        },
        red: {
            1000: "#610316",
            900: "#8A041A",
            800: "#AB091E",
            700: "#CF1124",
            600: "#E12D39",
            500: "#EF4E4E",
            400: "#F86A6A",
            300: "#FF9B9B",
            200: "#FFBDBD",
            100: "#FFE3E3",
        },
    },
    mediaQuery: {
        desktop: {
            default: `@media (min-width: 50rem)`,
        },
    },
}

export const customMUTheme = createMuiTheme({
    typography: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
    },
    palette: {
        primary: {
            main: defaultThemeValues.colors.primary[700],
            dark: defaultThemeValues.colors.primary[800],
            light: defaultThemeValues.colors.primary[500],
            contrastText: defaultThemeValues.colors.primary[100],
        },
        secondary: {
            main: defaultThemeValues.colors.primary[100],
            dark: defaultThemeValues.colors.primary[300],
            light: defaultThemeValues.colors.primary[100],
            contrastText: defaultThemeValues.colors.primary[1000],
        },
        text: {
            primary: defaultThemeValues.colors.grey[1000],
            secondary: defaultThemeValues.colors.grey[600],
            disabled: defaultThemeValues.colors.grey[200],
        },
        error: {
            main: defaultThemeValues.colors.red[600],
        },
        warning: {
            main: defaultThemeValues.colors.yellow[700],
        },
        success: {
            main: defaultThemeValues.colors.secondary[600],
            dark: defaultThemeValues.colors.secondary[700],
        },
    },
})
